import NotFound from 'pages/not-found';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import HistoryList from './history';
import OngoingList from './Ongoing';

const MentorshipMenteeManagementRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<OngoingList />} />
      <Route path="/history" element={<HistoryList />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorshipMenteeManagementRoutes;
